import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import { DatePicker } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 全局限制日期选择器：只能选择当前年的前8年到后8年
DatePicker.props.pickerOptions = {
  type: Object,
  default() {
    return {
      disabledDate(time) {
        const year = time.getFullYear()
        const currentYear = new Date().getFullYear()
        return year < currentYear - 8 || year > currentYear + 8
      }
    }
  }
}
import '_a/style/iconfont/iconfont.css'
import '_a/style/iconfont02/iconfont.css'
import file from '_l/file'
import { dateFormat } from '_l/format.js'
import { dateFormat2 } from '_l/format2.js'
import { dateFormat3 } from '_l/format3.js'
import config from '@/config/index.js'
// 引入文件操作相关插件
import OperationPlugins from '@/plugins/OperationPlugins.js'
// 引入上传组件
import uploader from 'vue-simple-uploader'
// 引入权限指令
import { setupPermissionDirective } from '@/directives/permission'

// import Vconsole from 'vconsole'
// let vConsole = new Vconsole()
// Vue.use(vConsole)

import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
dayjs.locale('zh-cn')

Vue.config.productionTip = false
Vue.config.devtools = true
Vue.use(ElementUI)
Vue.use(uploader)
// 注册权限指令
setupPermissionDirective(Vue)
Vue.prototype.$config = config
Vue.prototype[`$file`] = file // 挂载网盘相关公共方法
for (let key in OperationPlugins) {
  Vue.prototype[`$${key}`] = OperationPlugins[key]
}
Vue.filter('dateFormat', dateFormat)
Vue.filter('dateFormat2', dateFormat2)
Vue.filter('dateFormat3', dateFormat3)
export const EventBus = new Vue()

// 企微移动端：按视口宽度动态设置根字号，使 px→rem 样式等比缩放（仅 mobileWeCom 路由生效，PC 端不受影响）
function applyMobileRootFont() {
  const hash = window.location.hash || ''
  const isMobile = hash.indexOf('mobileWeCom') !== -1
  const docEl = document.documentElement
  if (isMobile) {
    const w = Math.min(docEl.clientWidth || window.innerWidth || 375, 750)
    docEl.style.fontSize = (w / 10) + 'px' // 1rem = 屏宽/10；基准 375 → 37.5px
  } else if (docEl.style.fontSize) {
    docEl.style.fontSize = '' // 还原为浏览器默认（16px），避免影响 PC 端
  }
}
applyMobileRootFont()
router.afterEach(function () { applyMobileRootFont() })
window.addEventListener('resize', applyMobileRootFont)
window.addEventListener('orientationchange', applyMobileRootFont)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
